module.exports = __webpack_public_path__ + "img/py.2cdca1f0.svg";